module.exports = __webpack_public_path__ + "static/media/032-dentist.d9c73e9d.svg";